import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'tf-option-with-info',
  standalone: true,
  imports: [TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './option-with-info.component.scss',
  template: `
    <div class="role-option-item">
      <span class="role-label">{{ label() }}</span>
      <i
        class="pi pi-info-circle role-info-icon"
        [pTooltip]="tooltip()"
        tooltipPosition="right"
        [showDelay]="150"
        [hideDelay]="150"
        appendTo="body"></i>
    </div>
  `,
})
export class OptionWithInfoComponent {
  readonly label = input.required<string>();
  readonly tooltip = input.required<string>();
}
